"use client";

import { useEffect } from "react";

const PRISMIC_ASSET_MARKERS = ["sendmagic", "prismic-nextjs", "old-swagmagic", "prismic"];
const MANAGED_ATTR = "data-old-swagmagic-prismic-managed";

const hasPrismicMarker = (node) => {
  if (!(node instanceof HTMLElement)) return false;
  const content = [
    node.tagName,
    node.getAttribute("src"),
    node.getAttribute("href"),
    node.dataset.href,
    node.dataset.nHref,
    node.getAttribute("id"),
    node.getAttribute("class"),
    node.dataset.chunk,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();

  return PRISMIC_ASSET_MARKERS.some((marker) => content.includes(marker));
};

const HeadStyleCleanupClient = () => {
  useEffect(() => {
    const isManagedNode = (node) => {
      if (!(node instanceof HTMLElement)) return false;
      const tag = node.tagName.toLowerCase();

      if (tag === "script") {
        return hasPrismicMarker(node);
      }

      if (tag === "style") {
        return hasPrismicMarker(node);
      }

      if (tag === "link") {
        const rel = (node.getAttribute("rel") || "").toLowerCase();
        const as = (node.getAttribute("as") || "").toLowerCase();
        const isStyleLink = rel === "stylesheet" || (rel === "preload" && as === "style");
        return isStyleLink && hasPrismicMarker(node);
      }

      return false;
    };

    const markIfManaged = (node) => {
      if (isManagedNode(node)) {
        node.dataset.oldSwagmagicPrismicManaged = "1";
      }
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach(markIfManaged);
      });
    });

    observer.observe(document.head, { childList: true });

    // In case assets were injected before observer attached.
    Array.from(document.head.children).forEach(markIfManaged);

    return () => {
      observer.disconnect();
      const nodes = Array.from(document.head.querySelectorAll(`[${MANAGED_ATTR}="1"]`));
      nodes.forEach((node) => node.remove());
    };
  }, []);

  return null;
};

export default HeadStyleCleanupClient;
